/**
 * @ngdoc directive
 * @name ng.directive:vFollow
 * @element ANY
 */

export default (vue) => {

    let link = atob( typeof vue.get(vue.exp) !== 'undefined' ? vue.get(vue.exp) : vue.exp);

    if ( 'ontouchstart' in document.documentElement ) {
        let timeout = 0;
        vue.el.addEventListener('touchstart', (e) => {
            timeout = setTimeout(() => {
                window.location = link;
            }, 200);
        }, {ive: true});
        vue.el.addEventListener('touchmove', () => {
            clearTimeout(timeout);
        }, {ive: true});
    } else {
        vue.el.addEventListener('click', (e) => {
            window.location = link;
        });
        if ( vue.el.tagName.toLowerCase() === 'a') {
            vue.el.addEventListener('mouseover', (e) => {
                vue.el.href = link;
            }, {ive: true});
            vue.el.addEventListener('mouseout', (e) => {
                vue.el.removeAttribute("href");
            }, {ive: true});
        }
    }
};